import React from 'react'
import { Helmet } from "react-helmet-async";

const Visuals = () => {
  return (
    <div style={{paddingTop: 25}}>

      <Helmet>
        <title>OES | Visuals</title>
        <meta name="description" content="Enjoy visual representation of aspects of Africa we represent" />
        <meta
          name="keywords"
          content="African, Nairobi, Growth, Economy, Culture, History, Politics, Society, Eclectic"
        />
        <meta property="og:title" content="Our Eclectic Society" />
        <meta property="og:description" content="Mindful thoughts and discussions about our continent" />
        {/*<meta property="og:image" content={img1} />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="400" />*/}
        <link rel="canonical" href="/visuals" />
      </Helmet>

      <div>
          <iframe
            width="100%" height="500"
            src="https://www.youtube.com/embed/jdxKQkcCtpQ?si=ZeMLtoE1RsQfzRrm"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
          </iframe>
      </div>
      <div>
        <iframe
          width="100%" height="500"
          src="https://www.youtube.com/embed/Hvq_qfSJvvY?si=8Tof7qj52MvLkZIJ"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
        </iframe>
      </div>
      <div>
          <iframe
            width="100%" height="500"
            src="https://www.youtube.com/embed/Sz57Crh0JZY?si=-UuM-lX7rClb15SZ"
            title="YouTube video player"
            frameborder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            referrerpolicy="strict-origin-when-cross-origin" allowfullscreen>
          </iframe>
      </div>
    </div>
  )
}

export default Visuals